export default {
  app: {
    languagePopup: {
      title: 'Attualmente sei nella versione inglese di {logo}',
      subtitle: 'Vuoi passare alla tua lingua preferita?',
      cta: 'Passa a {lang}',
    },
  },
};
